import { render, staticRenderFns } from "./CommandAreaList.vue?vue&type=template&id=659251d8&scoped=true"
import script from "./CommandAreaList.vue?vue&type=script&lang=js"
export * from "./CommandAreaList.vue?vue&type=script&lang=js"
import style0 from "./CommandAreaList.vue?vue&type=style&index=0&id=659251d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659251d8",
  null
  
)

export default component.exports